import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const assetsVuex = createNamespacedHelpers("assets");
const luckyVuex = createNamespacedHelpers("lucky");
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
export default {
  name: "lucky",
  //转盘抽奖
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...assetsVuex.mapState(["assetsList", "assetsChainsList"]),
    ...userVuex.mapState(["userData"]),
    ...luckyVuex.mapState(["luckyList", "luckyItems", "luckyLogs", "luckyLogHasMore", "luckyLoading", "luckyLogCondition"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      prizeIndex: 0,
      prizeList: null,
      isPopResult: false,
      //奖品结果弹窗显示状态
      selectRow: null,
      //抽到的奖品
      isStartLucky: false,
      //是否开始抽奖
      isLoadingLuckyList: null,
      //转盘列表loading
      isFlag: true,
      //防止按钮重复点击
      assetsInfo: {},
      isstockLoading: false,
      istapLoading: false,
      luckyInfo: {
        stock: {
          price_stock: 0,
          price_coin: 0,
          price_tap: 0
        },
        tap: {
          price_stock: 0,
          price_coin: 0,
          price_tap: 0
        }
      },
      awardInfo: {},
      scorllFlag: false,
      selectStockCountOption: 1,
      selectTapCountOption: 1,
      stockCountStep: 0,
      tapCountStep: 0,
      stockSelectCountOptions: 1,
      tapSelectCountOptions: 1,
      isSelectStock: -1,
      isSelectTap: -1,
      popSignShow: false,
      popUsdInviteShow: false,
      isGameRewardBalanceAnim: false
    };
  },
  watch: {
    isPopResult: {
      handler(bool) {
        if (!bool) {
          this.isGameRewardBalanceAnim = false;
        }
      }
    },
    deep: true
  },
  methods: {
    ...assetsVuex.mapActions(["getAssetsList"]),
    ...luckyVuex.mapActions(["getLuckyList", "getLuckyItems", "getLuckyLogs", "luckyDraw"]),
    ...luckyVuex.mapMutations(["setLuckyLogCondition", "setLuckyLogLoading"]),
    ...userVuex.mapMutations(["setUserData"]),
    setCountOption(type, selectType = "select") {
      const count_options = this.luckyInfo.count_options;
      const luckyInfo = this.luckyInfo;
      console.log("luckyInfo", luckyInfo, count_options);
      let tapBalance = this.assetsList?.[3].balance;
      if (!count_options && !luckyInfo) {
        return;
      }
      if (type == "stock") {
        if (selectType != "select") {
          this.stockCountStep = count_options.findLastIndex(item => {
            return this.userData.stock >= item * luckyInfo.stock.price_stock && this.userData.coin >= item * luckyInfo.stock.price_coin;
          });
        } else {
          if (this.stockCountStep >= count_options.length - 1) {
            this.stockCountStep = 0;
          } else {
            this.stockCountStep++;
          }
        }
        if (this.userData.stock < count_options[this.stockCountStep] * luckyInfo.stock.price_stock || this.userData.coin < count_options[this.stockCountStep] * luckyInfo.stock.price_coin) {
          this.stockCountStep = count_options.findIndex(item => {
            return this.userData.stock >= item * luckyInfo.stock.price_stock && this.userData.coin >= item * luckyInfo.stock.price_coin;
          });
        }
        if (this.userData.stock < count_options[0] * luckyInfo.stock.price_stock || this.userData.coin < count_options[0] * luckyInfo.stock.price_coin) {
          this.stockCountStep = 0;
        }
        this.stockSelectCountOptions = count_options[this.stockCountStep];
        this.isSelectStock = this.stockCountStep;
      } else if (type == "tap") {
        if (selectType != "select") {
          this.tapCountStep = count_options.findLastIndex(item => {
            console.log("item * luckyInfo.tap.price_tap", tapBalance, item * luckyInfo.tap.price_tap);
            return tapBalance >= item * luckyInfo.tap.price_tap;
          });
        } else {
          if (this.tapCountStep >= count_options.length - 1) {
            this.tapCountStep = 0;
          } else {
            this.tapCountStep++;
          }
        }
        if (tapBalance < count_options[this.tapCountStep] * luckyInfo.tap.price_tap) {
          this.tapCountStep = count_options.findIndex(item => {
            return tapBalance >= item * luckyInfo.tap.price_tap;
          });
        }
        if (tapBalance < count_options[0] * luckyInfo.tap.price_tap) {
          this.tapCountStep = 0;
        }
        console.log("tapBalance=====", tapBalance, count_options[this.tapCountStep] * luckyInfo.tap.price_tap, count_options[this.tapCountStep], luckyInfo.tap.price_tap, this.tapCountStep);
        this.tapSelectCountOptions = count_options[this.tapCountStep];
        this.isSelectTap = this.tapCountStep;
      }
    },
    //开始抽奖
    onStart(type) {
      //校验资格

      //开始转盘

      if (!this.isFlag) return;
      this.btnType = type;
      this.isFlag = false; //防止重复提交
      const vueLuckywheel = this.$refs.vueLuckywheel;
      if (!vueLuckywheel) {
        this.isFlag = true;
        return;
      }
      if (!this.prizeList && this.prizeList.length > 0) {
        this.isFlag = true;
        return;
      }
      const count = this.btnType == "stock" ? this.stockSelectCountOptions : this.tapSelectCountOptions;
      this.luckyDraw([this.luckyInfo.id, async res => {
        this.isStartLucky = true;
        if (res.user) {
          if (res.lottery.price_coin > 0) {
            res.user.coin = res.user.coin - res.lottery.price_coin;
          }
          let newUserData = {
            ...this.userData,
            ...res.user
          };
          this.setUserData(newUserData);
        }
        if (this.btnType == "tap" && this.$refs.nCurrencyTwoRef) {
          this.$refs.nCurrencyTwoRef.tonCurrency.tap.balance -= res.lottery.price_tap;
        }
        // res.winning_item = {
        //   id: 19,
        //   title: "x8",
        //   icon: "",
        //   disp_combo: ["TAPGIFTSHARD", "TAPGIFTSHARD", "TAPGIFTSHARD"],
        //   currency: "TAPGIFTSHARD",
        //   gift_extra: null,
        //   amount: {
        //     1: {
        //       type: 0,
        //       name: "",
        //       thumb: "https://static.tapcoins.app/202508/01/f272ca0f-67bf-4a15-81d7-4f72f5174c62.png",
        //       image: "https://static.tapcoins.app/202508/01/515c21a5-ff62-4dbe-be5c-823d5d0f0881.png",
        //       amount: 8,
        //     },
        //   },
        //   // amount: 2,
        //   unit_amount: 8,
        //   count: 1,
        //   log_id: 2784,
        //   user_gift_id: null,
        //   lround: -1,
        // };
        this.selectRow = {
          count: res.winning_item.count,
          amount: res.winning_item.amount,
          currency: res.winning_item.currency,
          user: res.user
        };
        //随机模拟中奖结果 随机数据索引
        //this.prizeIndex = Math.floor(Math.random() * this.prizeList.length);
        this.prizeList.forEach((item, index) => {
          if (item.id == res.winning_item.id) {
            this.awardInfo = res.winning_item;
            this.prizeIndex = index;
          }
        });
        this.isStartLucky = false;
        //执行转盘动画
        this.$nextTick(vueLuckywheel.draw);
      }, err => {
        this.isFlag = true;
      }, this.btnType, count]);
    },
    //中奖结果
    async onResult() {
      //显示中奖结果弹窗
      this.isPopResult = true;
      this.isStartLucky = false;
      this.isFlag = true;
      this.isGameRewardBalanceAnim = false;
      // this.setCountOption(this.btnType, 'result');
      const count_options = this.luckyInfo.count_options;
      const luckyInfo = this.luckyInfo;
      if (this.btnType == "stock") {
        const countStep = this.stockCountStep;
        this.stockCountStep = count_options.findLastIndex((item, index) => {
          return this.userData.stock >= item * luckyInfo.stock.price_stock && this.userData.coin >= item * luckyInfo.stock.price_coin;
        });
        if (this.isSelectStock >= 0) {
          this.stockCountStep = this.isSelectStock;
        }
        if (this.userData.stock < count_options[0] * luckyInfo.stock.price_stock || this.userData.coin < count_options[0] * luckyInfo.stock.price_coin) {
          this.stockCountStep = 0;
        }
        console.log("countStep123", countStep, this.stockCountStep);
        this.stockSelectCountOptions = count_options[this.stockCountStep >= 0 ? this.stockCountStep : count_options.length - 1];
      } else if (this.btnType == "tap") {
        const tapBalance = this.assetsList?.[3].balance;
        this.tapCountStep = count_options.findLastIndex(item => {
          return tapBalance >= item * luckyInfo.tap.price_tap;
        });
        if (this.isSelectTap >= 0) {
          this.tapCountStep = this.isSelectTap;
        }
        if (tapBalance < count_options[0] * luckyInfo.tap.price_tap) {
          this.tapCountStep = 0;
        }
        this.tapSelectCountOptions = count_options[this.tapCountStep >= 0 ? this.tapCountStep : count_options.length - 1];
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (this.$refs.nCurrencyRef) {
        await this.$refs.nCurrencyRef.getCurrencyData();
      }
      this.setUserData(this.selectRow.user);
      this.isGameRewardBalanceAnim = true;
      this.onLoadData(1);
      if (this.$refs.mDanmakuRef) {
        this.$refs.mDanmakuRef.executeDanmaku();
      }
      document.body.scrollTo({
        top: 0,
        left: 0
      });
    },
    //外围灯光动画
    lightAnimFn() {
      this.$nextTick(() => {
        const luckyTableAdroinRef = this.$refs.luckyTableAdroinRef;
        if (!luckyTableAdroinRef) return;
        luckyTableAdroinRef.style.setProperty("--image1", `url(${require(`@images/${this.theme}/lucky/light1.png`)})`);
        luckyTableAdroinRef.style.setProperty("--image2", `url(${require(`@images/${this.theme}/lucky/light2.png`)})`);
      });
    },
    //更新数据

    //获取转盘列表  不做配置就直接在data中写死
    async getLuckyListData() {
      this.isLoadingLuckyList = true;
      this.prizeList = [];
      await this.getLuckyItems(this.luckyInfo.id);
      this.luckyItems.forEach((item, index) => {
        this.prizeList.push({
          id: item.id,
          value: item.amount,
          unit: item.currency,
          type: item.currency.toLowerCase()
        });
      });
      this.isLoadingLuckyList = false;
    },
    onLoadData(page) {
      this.setLuckyLogCondition({
        lotteryId: this.luckyInfo.id,
        // lotteryId: 2,
        page: page,
        limit: 10
      });
      this.getLuckyLogs([() => {
        this.scorllFlag = false;
      }, () => {
        this.scorllFlag = false;
      }]);
    },
    checkScroll() {
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (!this.scorllFlag) {
        if (scrollTop + clientHeight >= scrollHeight - 50) {
          // 接近底部时触发加载
          this.scorllFlag = true;
          if (this.luckyLogHasMore && !this.luckyLoading) {
            let page = this.luckyLogCondition.page;
            this.onLoadData(page + 1);
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      console.log("this.$refs.nCurrencyRef", this.$refs.nCurrencyTwoRef);
      if (this.$refs.nCurrencyRef) {
        await this.$refs.nCurrencyRef.getCurrencyData();
      }
      if (this.$refs.nCurrencyTwoRef) {
        await this.$refs.nCurrencyTwoRef.getCurrencyData();
      }
      await this.getLuckyList(["official", 0]);
      if (this.luckyList && this.luckyList.length > 0) {
        const data = this.luckyList[0];
        this.luckyInfo = {
          ...data,
          stock: {
            price_stock: data.price_stock,
            price_coin: data.price_coin
          },
          tap: {
            price_tap: data.price_extras.hasOwnProperty("tap") ? data.price_extras?.tap.price_tap : 0,
            price_coin: data.price_extras.hasOwnProperty("tap") ? data.price_extras?.tap.price_coin : 0
          }
        };
        this.onLoadData(1);
        this.getLuckyListData();
        if (this.$refs.mDanmakuRef) {
          this.$refs.mDanmakuRef.getDanmakuInfo(this.luckyInfo.id);
        }
      }
      this.lightAnimFn();
      // await this.initFnc();
      window.addEventListener("scroll", this.checkScroll);
      this.setCountOption("stock", "init");
      this.setCountOption("tap", "init");
    });
  },
  beforeRouteLeave(to, from, next) {
    try {
      this.isPopResult = false;
      if (this.$refs.mDanmakuRef) {
        clearTimeout(this.$refs.mDanmakuRef.executTimer);
        this.$refs.mDanmakuRef.play("stop");
      }
      window.removeEventListener("scroll", this.checkScroll);
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  }
};